import { Vraag, Antwoord, ValidatieParameter } from '@models/claims';
import { IBaseVraagboomResultaat, VraagboomMultiResultaat } from '@models/vragenboom';
import { KentekenValidator, ValidatieregelHelper } from '@services/public_api';
import { IbanValidator } from './iban.validator';
import { RegexValidator } from './regex.validator';

// @dynamic
export class TekstregelsValidator {
  static isValid<TResultaat extends IBaseVraagboomResultaat>(vraag: Vraag, resultaat: TResultaat): boolean {
    if (vraag == null || (vraag.verplicht && resultaat == null)) {
      return false;
    }

    return true;
  }

  static isValidTekstregels(vraag: Vraag, resultaat: VraagboomMultiResultaat): boolean {
    if (vraag == null || (vraag.verplicht && resultaat == null)) {
      return false;
    }

    const numberOfAnswers: ValidatieParameter = ValidatieregelHelper.get(vraag.validatieParameters, 'MIN_MAX');
    if (numberOfAnswers != null && vraag.antwoorden?.length > 0) {
      const minMaxValue = numberOfAnswers.validatie_parameters.split(';');
      const min: number = Number(minMaxValue[0]);
      const max: number = Number(minMaxValue[1]);
      const antwoordCount = vraag.antwoorden.filter(a => a.waarde?.length > 0).length;

      if (!antwoordCount || min > antwoordCount || (max > 0 && antwoordCount > max)) {
        return false;
      }
    }

    let allValid = true;

    vraag.antwoorden.forEach((antwoord: Antwoord) => {
      if (allValid && !this.isValidValue(antwoord.waarde, antwoord)) {
        allValid = false;
      }
    });

    return allValid;
  }

  static isValidValue(value: string, antwoord: Antwoord) {    
    if (!antwoord) {
      return false;
    }

    // Check Verplicht
    if (!value || value.trim() === '') {
      return !antwoord.verplicht;
    }

    // Check Min en Max-Lengte
    const minLength: number = Number(antwoord.validatieParameters.find(v => v.type_validatie === 'MIN_LENGTE')?.validatie_parameters);
    if (minLength && !isNaN(minLength) && value.length < minLength) {
      return false;
    }

    const maxLength: number = Number(antwoord.validatieParameters.find(v => v.type_validatie === 'MAX_LENGTE')?.validatie_parameters);
    if (maxLength && !isNaN(maxLength) && value.length > maxLength) {
      return false;
    }

    // Check IBAN
    if (!IbanValidator.isValidIban(antwoord, antwoord.waarde)) {
      return false;
    }

    // Check Regex en kenteken
    if (!RegexValidator.isValidRegexAnswer(antwoord, antwoord.waarde) || !KentekenValidator.isValidKenteken(antwoord, antwoord.waarde)){
      return false;
    }

    return true;
  }
}
